module.exports = __webpack_public_path__ + "src/img/learn.e5bf1b98.png";